import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { thirdPartyColumnsData } from "assets/properties/properties";
import { removeUnderscores } from "utils/Utils";
const ThirdParty = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  // submit create function
  const handleCreateDueDiligence = () => {
    navigate(`/coreservice/ThirdParty-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.THIRD_PARTY_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.user_description) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data.forEach((role, index) => {
        let row = {
            index: index + 1,
          integration:role?.integration,
          enabled:role?.enabled === true ? "Yes" : "No",
          vendor:removeUnderscores(role?.vendor),
          action: getIcons(role?.id,role?.integration),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  // icons function
  const getIcons = (id,integration) => {
    return (
      <>
        <IconButton
          aria-label="Edit id"
          onClick={() => onClickUpdateData(id)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete id"
          onClick={() => onClickDeleteData(integration)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (id) => {
    navigate(`/coreservice/ThirdParty-create/` + id);
  };
  // delete function
  const onClickDeleteData = (id) => {
    setConfirmationModalHeader("Third Party");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteId(id);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteId("");
  };
  const handlePositiveResponse = async () => {
    const integrationName = deleteId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Role
    const res = await apiHandler({
      url: endpoint.THIRD_PARTY_DELETE + integrationName,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Delete is successful", true);
      GetData();
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.discrepancyName?.toLowerCase()?.includes(val?.toLowerCase())
      );
    });
    parseIndicatorData(filteredData);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Third Party"
          onSearchChange={onSearchChange}
          searchLabel="Search For Third Party"
          search
          button1="Create"
          button1click={handleCreateDueDiligence}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={thirdPartyColumnsData} rows={selectedTableData} />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

export default ThirdParty;
